import { Typography } from "@mui/material";
import { ReactNode } from "react";

import { GetTollFreeRegistrationQuery } from "~frontend/__generated__/graphql";
import ClickToCopy from "~frontend/components/ClickToCopy";
import { FlexBox } from "~frontend/components/FlexBox";
import Table from "~frontend/components/Table";

type InventoryPhoneNumberType =
  GetTollFreeRegistrationQuery["getTollFreeRegistration"]["inventoryPhoneNumbers"][number];

export const StaffTollFreePhoneNumberList = ({
  numbers,
}: {
  numbers: GetTollFreeRegistrationQuery["getTollFreeRegistration"]["inventoryPhoneNumbers"];
}): ReactNode => (
  <FlexBox direction="column">
    <Typography variant="h2Bold">Phone Numbers</Typography>

    <Table<InventoryPhoneNumberType>
      columns={[
        {
          key: "phoneNumber",
          title: (
            <FlexBox alignItems="center">
              Number{" "}
              <ClickToCopy
                iconSx={{ height: "15px" }}
                text={numbers.map(n => n.phoneNumber).join(",")}
              >
                <></>
              </ClickToCopy>
            </FlexBox>
          ),
          renderValue: row => row.phoneNumber,
          align: "left",
        },
        {
          key: "state",
          title: "Status",
          renderValue: row => {
            if (row.tollFreeVerificationRequests.length === 0) {
              return "Purchased, verification not yet started";
            }

            switch (row.tollFreeVerificationRequests[0].status) {
              case "PENDING":
                return "Verifying";
              case "VERIFIED":
                return "Verified";
              case "UNVERIFIED":
                return `Failed Verification: ${row.tollFreeVerificationRequests[0].declineReason ?? "Unknown"}`;
              case "INVALID_STATUS":
                return "Invalid status: please contact engineering";
              default:
                return row.state;
            }
          },
        },
        {
          key: "bandwidthTicketNumber",
          title: (
            <>
              <FlexBox alignItems="center" justifyContent="center">
                Bandwidth Ticket Number(s){" "}
                <ClickToCopy
                  iconSx={{ height: "15px" }}
                  text={numbers
                    .map(n =>
                      n.tollFreeVerificationRequests
                        .map(
                          ({ bandwidthTicketNumber }) => bandwidthTicketNumber
                        )
                        .filter(Boolean)
                        .join(", ")
                    )
                    .join(",")}
                >
                  <></>
                </ClickToCopy>
              </FlexBox>
            </>
          ),
          renderValue: row => {
            return row.tollFreeVerificationRequests
              .map(({ bandwidthTicketNumber }) => bandwidthTicketNumber)
              .filter(Boolean)
              .join(", ");
          },
        },
      ]}
      rows={numbers}
      emptyState="No numbers purchased yet"
      noFooter
    />
  </FlexBox>
);
